import { render, staticRenderFns } from "./SortHandler.vue?vue&type=template&id=1ef9ae29"
import script from "./SortHandler.vue?vue&type=script&lang=js"
export * from "./SortHandler.vue?vue&type=script&lang=js"
import style0 from "./SortHandler.vue?vue&type=style&index=0&id=1ef9ae29&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports